// Guard: snippet ყველა პროდუქტის ბარათზე ტვირთავს ამ სკრიპტს —
// ეს უზრუნველყოფს, რომ ლოგიკა მხოლოდ ერთხელ გაეშვას გვერდზე
if (!window.__inlineStarsLoaded) {
  window.__inlineStarsLoaded = true;

  document.addEventListener('DOMContentLoaded', async () => {
    const wrappers = [...document.querySelectorAll('[id^="inline-stars-wrapper-"]')];
    if (wrappers.length === 0) return;

    // ყველა productId ერთ სიაში — უნიკალური და დასორტირებული (სტაბილური URL = უკეთესი cache)
    const ids = [...new Set(
      wrappers.map(w => w.dataset.productId).filter(Boolean)
    )].sort();

    if (ids.length === 0) return;

    let results = {};

    try {
      const res = await fetch(`https://dashboard.dakhli.ge/api/reviews/batch?ids=${ids.join(',')}`);
      if (!res.ok) throw new Error('Batch request failed');
      results = await res.json();
    } catch (e) {
      console.error('Failed to load inline stars:', e);
      return;
    }

    wrappers.forEach((wrapper) => {
      const productId = wrapper.dataset.productId;
      const starContainer = wrapper.querySelector('.inline-stars');
      if (!productId || !starContainer) return;

      const rating = (results[productId] && results[productId].rating) || 0;

      if (rating === 0) {
        wrapper.style.display = 'none';
        return;
      }

      let starsHTML = '';
      for (let i = 0; i < 5; i++) {
        if (i < Math.floor(rating)) {
          starsHTML += '<span class="inline-star filled">★</span>';
        } else if (i < rating) {
          const fillWidth = (rating - i) * 100;
          starsHTML += `<span class="inline-star partial" style="--fill-width: ${fillWidth}%">★</span>`;
        } else {
          starsHTML += '<span class="inline-star">★</span>';
        }
      }

      starContainer.innerHTML = starsHTML;
      wrapper.style.display = 'flex';
      wrapper.style.visibility = 'visible';
    });

    if (window.location.href.includes('/products/')) {
      const style = document.createElement('style');
      style.innerHTML = `
        .inline-stars-wrapper {
          margin-top: 13px !important;
          margin-bottom: -5px !important;
        }
      `;
      document.head.appendChild(style);
    }
  });
}